import EcoAiEU from 'elem/compPage/stream-series-plug-in-solar-battery/pages/product/components/EcoAi';
import StepPortalEU from 'elem/compPage/stream-series-plug-in-solar-battery/pages/product/components/StepPortal';

interface EcoAiProps {
    pageType?: string;
}
const EcoAi: React.FC<EcoAiProps> = ({ ...props }) => {
    return (
        <div style={{ backgroundColor: '#000' }}>
            <EcoAiEU {...props} />
            <StepPortalEU {...props} />
        </div>
    );
};

export default EcoAi;
